import { postData } from '../utils/ajax-utils';

/* eslint-disable @typescript-eslint/no-explicit-any */
declare const script_var: any;

export default function initNotificationsDashboard(): void {
    const $notificationsContainer = document.querySelectorAll<HTMLElement>('.js-notifications-nav');
    $notificationsContainer.forEach($container => {
        new NotificationsDashboard($container);
    });
}

class NotificationsDashboard {
    $el: HTMLElement;
    $body: HTMLElement | null;
    $openButton: HTMLElement | null;
    $notificationsIcon: HTMLElement | null;
    $dashboardContent: HTMLElement | null;
    $preferencesOpenButton: HTMLButtonElement | null;
    $preferencesCloseButton: HTMLButtonElement | null;
    $preferencesModal: HTMLDialogElement | null;
    $closeButton: HTMLButtonElement | null;

    constructor($el: HTMLElement) {
        this.$el = $el;
        this.$body = document.querySelector<HTMLElement>('body');
        this.$dashboardContent = this.$body?.querySelector<HTMLElement>('.dashboard-content') ?? null;
        this.$openButton = this.$body?.querySelector<HTMLElement>('.js-notifications-link') ?? null;
        this.$notificationsIcon = this.$openButton?.querySelector<HTMLElement>('.notification') ?? null;
        this.$preferencesOpenButton = this.$el.querySelector<HTMLButtonElement>('.js-pref-btn');
        this.$preferencesCloseButton = this.$el.querySelector<HTMLButtonElement>('.close-button-modal-preferences-dashboard');
        this.$closeButton = this.$el.querySelector<HTMLButtonElement>('.js-close-btn');
        this.$preferencesModal = this.$el.querySelector<HTMLDialogElement>('.modal-preferences-dashboard');

        if (this.$openButton) {
            this.toggleNavHandler(this.$openButton);
        }

        if (this.$closeButton) {
            this.toggleNavHandler(this.$closeButton);
        }

        this.openModal();
    }

    initStickyNavigation() {
        if (window.scrollY > 20) {
            this.$el.classList.add('notifications-nav--sticky');
        } else {
            this.$el.classList.remove('notifications-nav--sticky');
        }
    }

    toggleNavHandler(button: Element | HTMLButtonElement): void {
        button.addEventListener('click', () => {
            // nav
            this.$el.classList.toggle('notifications-nav--active');
            this.initStickyNavigation();

            // content
            this.$dashboardContent?.classList.toggle('dashboard-content--disabled');

            // body
            this.$body?.classList.toggle('prevent-scroll');

            // S'il y a des notifications non lues,
            // on les marques comme lues au moment où on ouvre le panneau des notifs
            const nbNotifsNotRead = parseInt(this.$notificationsIcon?.innerText ?? '0');
            if (nbNotifsNotRead) {
                postData(script_var.ajax_url, {
                    action: 'mark_notifications_as_read',
                    user_id: this.$openButton?.dataset.userId ?? '',
                });

                // On masque le nombre de notifications
                if (this.$notificationsIcon) {
                    this.$notificationsIcon.remove();
                }
            }
        });
    }

    openModal() {
        this.$preferencesOpenButton?.addEventListener('click', () => {
            this.$preferencesModal?.showModal();
        });

        this.$preferencesCloseButton?.addEventListener('click', () => {
            this.$preferencesModal?.close();
        });

        // Auto open de la modal
        if (typeof this.$preferencesOpenButton?.dataset.autoOpen !== 'undefined'
            && this.$preferencesOpenButton?.dataset.autoOpen !== 'false'
        ) {
            this.$openButton?.click();
            this.$preferencesOpenButton?.click();
        }
    }
}
